// extracted by mini-css-extract-plugin
export default {"errorText":"errorComponent_errorText__Uv01o"};